export var InstagramImagesStepsEnum;
(function (InstagramImagesStepsEnum) {
    InstagramImagesStepsEnum["PROFESSIONAL_INSTAGRAM_IMAGE_KEY"] = "professional_instagram_image_key";
    InstagramImagesStepsEnum["LINKED_ACCOUNTS_IMAGE_KEY"] = "linked_accounts_image_key";
    InstagramImagesStepsEnum["MESSAGES_ACCESS_IMAGE_KEY"] = "messages_access_image_key";
})(InstagramImagesStepsEnum || (InstagramImagesStepsEnum = {}));
